export default [

    //   //  快手 - 兔年尊享包
    //   {
    //       path: '/rabbitExclusive-k',
    //       name: '/rabbitExclusive-k',
    //       meta:{
    //           title:'兔年尊享包',
    //       },
    //       component: () => import('@/view/kuaishou/rabbitExclusiveSigning-k'),
    //   },
    //   //  快手 - 会员月月领
    //   {
    //       path: '/vipMonthMonthReceiveNew-k',
    //       name: '/vipMonthMonthReceiveNew-k',
    //       meta:{
    //           title:'会员月月领',
    //       },
    //       component: () => import('@/view/kuaishou/vipMonthMonthReceiveNew-k'),
    //   },
    // // 快手 - Vip会员月月领
    //   {
    //       path: '/vipMemberMouthMouthNeckFirm-k',
    //       name: '/vipMemberMouthMouthNeckFirm-k',
    //       meta:{
    //           title:'会员月月领',
    //       },
    //       component: () => import('@/view/kuaishou/vipMemberMouthMouthNeckFirm-k'),
    //   },

]
